import * as React from "react";
import Die from "../die";
import DieFaceDisplay from "./dieFaceDisplay";
import { Col } from "react-bootstrap";

interface WholeDieProps {
    die: Die;
    index: number;
    currentRoll: number;
    selected: boolean;
}

const WholeDieDisplay: React.SFC<WholeDieProps> = (props) => <Col xs={2}>
    {props.die.faces.map((face, i) => <DieFaceDisplay key={i} face={face} dieIndex={props.index} currentRoll={props.currentRoll == i} selectedRoll={props.currentRoll == i && props.selected} />)}
</Col>

export default WholeDieDisplay;